import type { ValorantRegion, ValorantServer } from 'generated/openapi';

export const SERVERS_BY_REGION: Record<ValorantRegion, ValorantServer[]> = {
  NA: [
    'US_WEST_OREGON',
    'US_WEST_CALIFORNIA',
    'US_EAST_VIRGINIA',
    'US_CENTRAL_TEXAS',
    'US_CENTRAL_ILLINOIS',
    'US_CENTRAL_GEORGIA',
  ],
  LATAM: ['SANTIAGO', 'MEXICO_CITY', 'MIAMI'],
  BR: ['SAO_PAULO'],
  EU: [
    'FRANKFURT',
    'PARIS',
    'STOCKHOLM',
    'ISTANBUL',
    'LONDON',
    'WARSAW',
    'MADRID',
    'BAHRAIN',
  ],
  KR: ['SEOUL'],
  AP: ['HONG_KONG', 'TOKYO', 'SINGAPORE', 'SYDNEY', 'MUMBAI', 'MANILA'],
  UNKNOWN: [],
};

export const SERVER_DISPLAY_NAMES: Record<ValorantServer, string> = {
  // NA
  US_WEST_OREGON: 'US West (Oregon)',
  US_WEST_CALIFORNIA: 'US West (N. California)',
  US_EAST_VIRGINIA: 'US East (N. Virginia)',
  US_CENTRAL_TEXAS: 'US Central (Texas)',
  US_CENTRAL_ILLINOIS: 'US Central (Illinois)',
  US_CENTRAL_GEORGIA: 'US Central (Georgia)',
  // LATAM
  SANTIAGO: 'Santiago',
  MEXICO_CITY: 'Mexico City',
  MIAMI: 'Miami',
  // BR
  SAO_PAULO: 'Sao Paulo',
  // EU
  FRANKFURT: 'Frankfurt',
  PARIS: 'Paris',
  STOCKHOLM: 'Stockholm',
  ISTANBUL: 'Istanbul',
  LONDON: 'London',
  WARSAW: 'Warsaw',
  MADRID: 'Madrid',
  BAHRAIN: 'Bahrain',
  // KR
  SEOUL: 'Seoul',
  // AP
  HONG_KONG: 'Hong Kong',
  TOKYO: 'Tokyo',
  SINGAPORE: 'Singapore',
  SYDNEY: 'Sydney',
  MUMBAI: 'Mumbai',
  MANILA: 'Manila',
};

export function getServerDisplayName(server: ValorantServer): string {
  return SERVER_DISPLAY_NAMES[server];
}

export function getServersForRegion(region: ValorantRegion): ValorantServer[] {
  return SERVERS_BY_REGION[region];
}

/** Returns true for regions with only one server (BR, KR) */
export function isAutoSelectRegion(region: ValorantRegion): boolean {
  return region === 'BR' || region === 'KR';
}

/** Returns the server region for a given server */
export function getServerRegion(server: ValorantServer): ValorantRegion {
  for (const [region, servers] of Object.entries(SERVERS_BY_REGION)) {
    if (servers.includes(server)) {
      return region as ValorantRegion;
    }
  }
  return 'UNKNOWN';
}

/** Returns mutual servers between two server sets */
export function getMutualServers(
  servers1: ValorantServer[] | undefined,
  servers2: ValorantServer[] | undefined,
): ValorantServer[] {
  if (!servers1 || !servers2) return [];
  return servers1.filter(s => servers2.includes(s));
}
